import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { H1Header } from "../../shared/components/others";
import { useNavigate } from "react-router-dom";
import { usePurchaseTokensMutation } from "../../redux/slices/paymentApiSlice";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const TokenPacks = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.auth).userInfo;
  const [purchaseToken, { isLoading: settingup }] = usePurchaseTokensMutation();
  const [pack1Loading, setPack1Loading] = useState(false);
  const [pack2Loading, setPack2Loading] = useState(false);
  const [pack3Loading, setPack3Loading] = useState(false);
  const handleTokenPurchase = async (index, id) => {
    if (index == 0) {
      setPack1Loading(true);
    } else if (index == 1) {
      setPack2Loading(true);
    } else {
      setPack3Loading(true);
    }
    const res = await purchaseToken({ pack_type: id }).unwrap();
    if (res?.status == 200) {
      setPack1Loading(false);
      setPack2Loading(false);
      setPack3Loading(false);
      window.location.href = res?.checkout_url;
    } else {
      toast.error(res?.detail);
    }
  };
  const seo_tokens = [
    {
      id: "5_tokens",
      price: 15,
      nb_tokens: 5,
      disabled: pack1Loading || pack2Loading || pack3Loading,
      loading: pack1Loading,
      buttonText: t("Buy-token-pack", "Acheter le pack de jetons"),
      features_list: ["F1", "F2"],
    },
    {
      id: "15_tokens",
      price: 40,
      nb_tokens: 15,
      disabled: pack1Loading || pack2Loading || pack3Loading,
      loading: pack2Loading,
      buttonText: t("Buy-token-pack", "Acheter le pack de jetons"),
      features_list: ["F1", "F2"],
    },
    {
      id: "30_tokens",
      price: 75,
      nb_tokens: 30,
      disabled: pack1Loading || pack2Loading || pack3Loading,
      loading: pack3Loading,
      buttonText: t("Buy-token-pack", "Acheter le pack de jetons"),
      features_list: ["F1", "F2"],
    },
  ];
  useEffect(() => {
    if (userInfo?.payment_status != "active") {
      navigate("/pricing");
    }
  }, [userInfo]);
  return (
    <>
      <div className="px-2 pl-6 pr-6">
        <Helmet>
          <title> {t("SEO-token-packs", "SEO Token Packs")} | BotBlogR</title>
          <meta
            name="description"
            content="Vision générale de votre compte et de vos activités."
          />
        </Helmet>

        <div className="flex flex-col md:flex-row items-center justify-center lg:justify-end">
          <button
            onClick={() => {
              navigate("/pricing");
            }}
            className="hover:bg-blue-200 *: bg-blue-100 text-white disabled:bg-slate-200
           disabled:text-slate-400 font-light px-5 py-[6px] rounded flex items-center"
          >
            {t("pricing-and-plans", "Tarifs et formules")}
          </button>
        </div>
        <div className="py-3 flex flex-col w-full justify-center items-center gap-5">
          <H1Header title={t("SEO-token-packs", "SEO Token Packs")} />
          <p>Besoin d’effectuer plus d’analyses SEO sans changer d’abonnement ? Découvre nos packs de jetons pour booster ta stratégie, à la demande.</p>
        </div>
        <div className="mt-8 container space-y-12 lg:space-y-0 gap-y-8 lg:grid lg:grid-cols-3 lg:gap-x-8">
          {seo_tokens.map((token, tierIndex) => (
            <div
              key={`${token.id}-${tierIndex}`}
              className="relative p-6 md:p-8 border border-gray-200 rounded-2xl shadow-lg flex flex-col bg-white text-black"
            >
              <div className="flex-1">
                <h2 className="text-xl font-semibold text-center">
                  {token.nb_tokens}{" "}{t("SEO-Anlysis-Tokens", "SEO Anlysis Tokens")}
                </h2>
                <p className="mt-4 flex items-baseline justify-center">
                  <span className="text-6xl font-bold text-blue-100">
                    {token.price}
                  </span>
                  <span className="text-4xl font-bold text-blue-100">€</span>
                </p>
                <div className="flex flex-col items-center">
                  {/* Button */}
                  <button
                    onClick={() => {
                      handleTokenPurchase(tierIndex, token.id);
                    }}
                    className={`mt-6 block w-full py-3 px-6 rounded-md text-center font-semibold border-2 border-solid transition transform ${
                      token.disabled
                        ? "bg-gray_local-400 text-white border-gray_local-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-blue-100 to-blue-50 text-white border-transparent hover:from-blue-50 hover:to-blue-100 hover:scale-105"
                    }`}
                    disabled={token.disabled}
                  >
                    {!token.loading ? (
                      token?.buttonText
                    ) : (
                      <ClipLoader size={25} color="white" />
                    )}
                  </button>

                  {/* Secure Payment Text */}
                  <p className="flex items-center mt-2 text-sm text-gray-500">
                    <span className="mr-1">🔒</span>
                    {t("secure-payments-by", "Secure payments by")}
                    <strong className="ml-1">Stripe</strong>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default TokenPacks;
